import { render } from "./MdIcon.vue?vue&type=template&id=3cb6060c"
import script from "./MdIcon.vue?vue&type=script&lang=js"
export * from "./MdIcon.vue?vue&type=script&lang=js"

import "./MdIcon.vue?vue&type=style&index=0&id=3cb6060c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__